var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AtomGraphic',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    trigger: 'click hover',
    content: _vm.content,
  }),expression:"{\n    trigger: 'click hover',\n    content,\n  }"}],class:_vm.css(),attrs:{"name":"info","size":16,"color":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }